import semver from "semver";

const normalizeSemver = (version: string): string => {
  const match = version.match(/(\d+)\.(\d+)\.(\d+)(.*)?/);
  if (!match) {
    return "0.0.0";
  }

  const normalizedCore = [match[1], match[2], match[3]]
    .map((segment) => String(Number(segment)))
    .join(".");

  return `${normalizedCore}${match[4] || ""}`;
};

export default {
  flatten(version: string): string {
    /* ignore build number */
    const splitVersion = version.split(".");
    const comparableVersion =
      splitVersion.length > 3 ? splitVersion.slice(0, 3).join(".") : version;
    return normalizeSemver(comparableVersion);
  },
  greaterThan(version1: string, version2: string): boolean {
    return semver.gt(this.flatten(version1), this.flatten(version2));
  },
  lessThan(version1: string, version2: string): boolean {
    return semver.lt(this.flatten(version1), this.flatten(version2));
  },
  isSecondVersionHigher(version1: string, version2: string): boolean {
    return semver.gt(this.flatten(version2), this.flatten(version1));
  },
  isProduction(): boolean {
    return process.env.VUE_APP_USER_ENV == "production";
  },
};
